<template>
<!--- Use Shared Lib Login component -->
  <login :module="module" :googleClientId="googleClientId" :port="port" />
</template>

<script>
import { config } from "@/config";
export default {
  data() {
    return {
      googleClientId: config.GOOGLE_CLIENT_ID,
      module: process.env.VUE_APP_MODULE,
      port: process.env.VUE_APP_PORT,
    };
  },
};
</script>
